export default __webpack_public_path__ + "static/media/flyBy.8612835b.png";